/* eslint-disable react/no-array-index-key */
import React from 'react'
import cx from 'classnames'
import Skeleton from 'react-loading-skeleton'

import styles from './Tariff.module.scss'

import {
  Table,
} from '../../shared/componets/Tariff'
import { CardSkeleton } from '../../shared/componets/Tariff/Card/Card.skeleton'

export const TariffSkeleton: React.FC = () => {
  const tariffs = [...Array(3).fill(1)]

  return (
    <div className={styles.root}>

      {/* <div className={styles.wrapper}>
        <div className={styles.section}>
          <div className={styles.header}>
            <Logo />
            <Cross className={styles.cross} />
          </div>
        </div>
      </div> */}

      <div className={styles.section}>
        <Skeleton className={styles.title} style={{ marginBottom: 10 }} />

        <Skeleton className={styles.subtitle} />

        <div className={styles.buttons}>
          <Skeleton className={styles.button} />

          <Skeleton className={styles.button} />
        </div>

        <div className={styles.cards}>
          {tariffs.map((value, idx) => (
            <CardSkeleton
              key={value + idx}
            />
          ))
          }
        </div>
      </div>

      <div className={cx(styles.sectiontable, styles.section)}>
        <Skeleton className={styles.title} style={{ marginBottom: 10 }} />
        <Skeleton className={styles.subtitle} />

        <div className={styles.table}>
          <Table subscribes={tariffs} loading />
        </div>
      </div>

    </div>
  )
}
